import React from 'react';
import InputMask from 'react-input-mask';
import { observer } from '../../shared/observer';
import { makeConsentsHelpers } from './Consents';

class PhoneCallLoginView extends React.Component {
  state = { phone: '', step: 'phone', callTo: '', qrCode: '', error: null, sending: false, agrees: {} };

  componentWillUnmount() {
    this._unmounted = true;
    this.props.auth.stopCallStatusPolling();
  }

  componentWillReceiveProps(next) {
    if (next.auth && next.auth.isAuthenticated) {
      this.props.auth.stopCallStatusPolling();
      this.props.onAuthed && this.props.onAuthed();
    }
  }

  setPhone = (e) => this.setState({ phone: e.target.value, error: null });

  submit = async (e) => {
    e.preventDefault();
    if (this.state.sending) return;
    const digits = this.state.phone.replace(/\D/g, '');
    if (!digits) return;
    this.setState({ sending: true, error: null });
    try {
      const res = await this.props.auth.submitPhoneForCall(digits);
      if (res && res.restart_now) {
        // тестовый аккаунт — уже залогинены, ребутстрапим
        await this.props.auth.bootstrap();
        this.props.onAuthed && this.props.onAuthed();
        return;
      }
      // диалог могли закрыть, пока запрос был в полёте — не трогаем state
      // и не запускаем поллинг на размонтированном компоненте
      if (this._unmounted) return;
      this.setState({
        step: 'await',
        callTo: (res && res.phone) || '',
        qrCode: (res && res.qr_code) || '',
        sending: false,
      });
      this.props.auth.startCallStatusPolling(() => {
        this.props.onAuthed && this.props.onAuthed();
      });
    } catch (err) {
      if (this._unmounted) return;
      this.setState({ error: err.message || 'Не удалось отправить номер', sending: false });
    }
  };

  render() {
    const { phoneMaskInfo } = this.props.auth;
    const mask = phoneMaskInfo.phone_mask || '+9 (999) 999-99-99';
    if (this.state.step === 'await') {
      return (
        <div className="login-box">
          <div className="h1">Позвоните на номер</div>
          <p>
            С номера <strong>{this.state.phone}</strong> позвоните на:
          </p>
          <a className="btn" href={`tel:+${this.state.callTo.replace(/\D/g, '')}`}>{this.state.callTo}</a>
          {this.state.qrCode && (
            <div className="ng-qr-login">
              <img className="ng-img" src={this.state.qrCode} alt="QR-код для звонка" />
              <span>Сосканируйте QR-код камерой телефона, чтобы быстро набрать номер.</span>
            </div>
          )}
          <p style={{ fontSize: 13, color: 'var(--ng-fg-muted)' }}>
            Звонок будет сброшен — это бесплатно. Мы проверим номер и автоматически войдём в кабинет.
          </p>
          <span className="ng-loading-hint">Ожидаем ваш звонок…</span>
          <a href="#" onClick={(e) => { e.preventDefault(); this.props.auth.stopCallStatusPolling(); this.setState({ step: 'phone' }); }} style={{ fontSize: 13 }}>
            Изменить номер
          </a>
        </div>
      );
    }
    const consents = makeConsentsHelpers(this);
    const canSubmit = !this.state.sending && consents.ok();
    return (
      <form className="login-box" onSubmit={(e) => { if (!canSubmit) { e.preventDefault(); return; } this.submit(e); }}>
        <div className="h1">Личный кабинет</div>
        <InputMask
          className="input__text"
          mask={mask}
          maskChar="_"
          value={this.state.phone}
          onChange={this.setPhone}
          type="tel"
          placeholder={mask}
          autoFocus
        />
        {this.state.error && <div className="order-message">{this.state.error}</div>}
        {consents.render()}
        <button type="submit" className={'btn ' + (canSubmit ? '' : 'btn--disabled') + (this.state.sending ? ' is-busy' : '')} disabled={!canSubmit}>
          Далее
        </button>
      </form>
    );
  }
}

export const PhoneCallLogin = observer(PhoneCallLoginView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Auth/PhoneCallLogin.jsx